<template>
  <div>
    <v-card class="white elevation-3 ma-4">
      <toolbar
          :filters="filters"
          @search="searchIncidents"
      />
    </v-card>
    <v-card class="ma-4">
      <v-tabs
          v-model="tabIndex"
      >
        <v-tab
            v-for="(item, index) in tabItems"
            :key="item.name"
            :tab-value="index"
            active-class="primary--text"
            class="subheading text-capitalize tab-item"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items :value="tabIndex">
        <v-tab-item eager>
          <incidents-table
              ref="incomplete"
              :completed="false"
              :filters="filters"
              @returnTotal="setIncompleteTotal"
          />
        </v-tab-item>
        <v-tab-item eager>
          <incidents-table
              ref="completed"
              :completed="true"
              :filters="filters"
              @returnTotal="setCompletedTotal"
          />
        </v-tab-item>
        <v-tab-item eager>
          <incidents-table
              ref="failed"
              :completed="false"
              :failed-only="true"
              :filters="filters"
              @returnTotal="setFailedTotal"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import IncidentsTable from '@/components/Neris/IncidentsList/IncidentsTable';
import Toolbar from '@/components/Neris/IncidentsList/Toolbar';
import { SET_TITLE } from '@/store/mutations';

export default {
  components: { Toolbar, IncidentsTable },
  data() {
    return {
      loading: true,
      tabIndex: 0,
      incompleteTotal: 0,
      completeTotal: 0,
      failedTotal: 0,
      filters: {
        incidentDateRange: null,
        incidentNumber: null,
        sequenceNumber: null,
        showNonCad: false,
      },
    };
  },
  computed: {
    tabItems() {
      return [
        {
          id: 'incomplete',
          name: `Incomplete ${this.incompleteTotal ? ` (${this.incompleteTotal})` : ''}`,
        },
        {
          id: 'completed',
          name: `Completed ${this.completeTotal ? ` (${this.completeTotal})` : ''}`,
        },
        {
          id: 'failed',
          name: `Failed ${this.failedTotal ? ` (${this.failedTotal})` : ''}`,
        },
      ];
    },
  },
  methods: {
    searchIncidents(filters) {
      this.filters = filters;
      this.$refs.incomplete.search();
      this.$refs.completed.search();
      this.$refs.failed.search();
    },

    setIncompleteTotal(total) {
      this.incompleteTotal = total;
    },

    setCompletedTotal(total) {
      this.completeTotal = total;
    },

    setFailedTotal(total) {
      this.failedTotal = total;
    },

  },
  mounted() {
    this.$store.commit(SET_TITLE, 'NERIS Incidents');
  },
};
</script>
